import { IonButton, IonButtons, IonContent, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import ProcedureDataItem from '../../components/ProcedureDataItem'
import { ACCEPTED, ENDED } from '../../const/constants'
import { SPANISH_STATES } from '../../const/texts'
import { formatDetailDate } from '../../utils/utils'

const PortabilityDetails = () => {
  const procedure = useSelector((state: any) => state.storedProcedure)
  const history = useHistory()
  return (
    <IonPage>
      <header>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={(e) => history.push('/procedures/portabilidades')}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Consulta de trámite</IonTitle>
        </IonToolbar>
      </header>
      <IonContent>
        <main className="detail">
          <div className="detail-container">
            <ProcedureDataItem label="Fecha de ingreso" data={formatDetailDate(procedure?.creationDate)} />
            <ProcedureDataItem label="Número de trámite" data={procedure?.secOperationId} />
            <ProcedureDataItem label="Documento" data={procedure?.identificationNumber} />
            <ProcedureDataItem
              label="Número de línea provisorio"
              data={procedure?.cluCellularNumber}
              enlighten={procedure?.state === ACCEPTED}
            />
            <ProcedureDataItem
              label="Número de línea a portar"
              data={procedure?.specialCellularNumber}
              enlighten={procedure?.state === ENDED}
            />
            <ProcedureDataItem label="Nombres" data={procedure?.name} />
            <ProcedureDataItem label="Apellidos" data={procedure?.surname} />
            <ProcedureDataItem label="Nacionalidad" data={procedure?.country} />
            {procedure?.email && <ProcedureDataItem label="Correo electrónico" data={procedure?.email} />}
            <ProcedureDataItem label="Estado" data={SPANISH_STATES[procedure?.state]} />
            <ProcedureDataItem label="Negocio" data="Portabilidad Prepaga" />
          </div>
        </main>
      </IonContent>
    </IonPage>
  )
}

export default PortabilityDetails
